@if (isOpen()) {
	<div
		class="bg-primary-100 dark:bg-standard shadow-[-6px_-6px_6px_0_rgba(0,0,0,0.05)] fixed left-0 right-0 bottom-14.5 w-full max-h-[80vh] overflow-y-scroll rounded-t-3xl px-12 py-8"
		data-id="mobile-nav-list"
	>
		@for (item of submenuItems(); track item.name) {
			<ui-mobile-sub-nav-list-entry
				[item]="item"
				[isSubmenuOpen]="
					currentlyOpenedSubmenu() === item || childrenAreActive(item) || !!item.active
				"
				[currentUrl]="currentUrl()"
				[navColor]="navColor()"
				(clicked)="toggleEntry($event)"
			>
			</ui-mobile-sub-nav-list-entry>
		}
	</div>
}
